// Central content store for Yash Kankaria's editorial brand site.

export const PROFILE = {
  name: "Yash Kankaria",
  role: "Group Head — Brand & Business Leader",
  tagline:
    "Building brands that grow businesses through strategy, creativity and flawless execution.",
  location: "Bengaluru, India",
  phone: "+91 77603 48212",
  email: "kankariayash97@gmail.com",
  linkedin: "https://www.linkedin.com/in/yashkankaria/",
  portfolio: "#",
};

export const AT_A_GLANCE = [
  { value: "8+", label: "Years Experience" },
  { value: "₹4Cr+", label: "Annual Business Managed" },
  { value: "₹6Cr+", label: "FY26–27 Target Portfolio" },
  { value: "140%", label: "Business Growth" },
  { value: "95%", label: "Client Retention" },
  { value: "70+", label: "Industry Awards" },
  { value: "9", label: "People Led" },
  { value: "₹1.8Cr", label: "Largest Campaign Budget" },
];

export const TIMELINE = [
  {
    title: "Group Head",
    company: "Social Panga",
    period: "May 2026 — Present",
    summary:
      "Leading one of the agency's largest business portfolios while driving commercial growth, integrated campaign leadership and people management.",
    stats: [
      { k: "Business Managed", v: "₹4Cr+" },
      { k: "Team", v: "9 Members" },
      { k: "Portfolio", v: "8 Retainers + Special Projects" },
    ],
  },
  {
    title: "Associate Group Head",
    company: "Social Panga",
    period: "2026",
    summary: "Promoted to scale business growth and lead larger client mandates.",
    highlights: [
      "Managed ₹3Cr+ annual business",
      "140% business growth",
      "Expanded team from 2 to 8",
      "Delivered ₹50L+ campaigns within 30 days",
    ],
  },
  {
    title: "Senior Brand Manager",
    company: "Social Panga",
    period: "2022 — 2026",
    summary:
      "Owned integrated campaign execution across production, digital, websites, SEO, PR and awards.",
    highlights: [
      "Built Awards & PR capability",
      "50+ campaign awards",
      "Led integrated production projects",
    ],
  },
  {
    title: "Brand Solutions Executive",
    company: "Social Panga",
    period: "2021 — 2022",
    summary:
      "Managed multiple retainers while rapidly expanding into integrated communications.",
    highlights: [
      "NFT launch during COVID",
      "Website transformation projects",
      "Multi-brand account management",
    ],
  },
  {
    title: "Category Manager",
    company: "Swiggy",
    period: "May 2018 — January 2021",
    summary:
      "Managed merchant partnerships, business growth and category performance.",
  },
];

export const IMPACT = [
  { label: "Revenue", value: "₹4Cr+", note: "Current Business Managed" },
  { label: "Growth", value: "140%", note: "Business Growth Delivered" },
  { label: "Retention", value: "95%", note: "Client Retention" },
  { label: "Production", value: "25+", note: "Integrated Films" },
  { label: "Awards", value: "70+", note: "Industry Awards" },
  { label: "Leadership", value: "9", note: "Team Members" },
];

export const CLIENTS = {
  Healthcare: ["Manipal Hospitals", "Novo Nordisk"],
  Retail: [
    "Reliance Yousta",
    "Helios — A Titan Company",
    "Babyshop Arabia",
    "Popeyes India",
    "Khimji Jewellers",
  ],
  FMCG: [
    "Nestlé Munch",
    "Nestlé KitKat",
    "Nestlé Milkybar",
    "Himalaya Facecare",
    "Emami Healthy & Tasty",
    "Kwality Foods",
  ],
  Technology: [
    "Money View",
    "Shoonya",
    "GoKiwi",
    "Udaan",
    "Amaron Quanta",
  ],
};

export const CAMPAIGNS = [
  {
    slug: "guardians-of-the-heart",
    title: "Guardians of the Heart",
    brand: "Manipal Hospitals",
    year: "World Heart Day · 2022",
    tagline: "Stop. Scan. Save.",
    image:
      "https://customer-assets.emergentagent.com/job_yash-brand-portfolio/artifacts/u2hjbigo_WhatsApp%20Image%202026-06-30%20at%201.20.28%20AM.jpeg",
    context:
      "85% of cardiac arrests in India happen outside the hospital. The window to save a life is measured in minutes, and immediate bystander CPR is the only thing that triples survival odds. India had no public CPR culture to fall back on.",
    challenge:
      "90% of Indians who suffer an out-of-hospital cardiac arrest don't survive. Immediate CPR doubles or triples the chance of survival — but only 2% of Indians know how to perform it.",
    insight:
      "People look away from public health messaging. They don't look away from disruption. Bengaluru's daily ritual — sitting at a red light — became our distribution channel.",
    solution:
      "We caught Bengaluru where it was always stuck — at red lights. Heart-shaped red traffic signals across the city, paired with QR codes that taught CPR in 60 seconds. Extended to schools, colleges, malls, cafes and parks. A city, retrofitted to save lives.",
    execution:
      "Launched on World Heart Day 2022 in partnership with the BBMP. Heart-shaped red signals installed at junctions across Brigade Road, MG Road and Bellary Road. Each signal flanked by a QR-coded board linking to a 60-second CPR tutorial. Amplified through OOH at schools, colleges, malls, cafes and parks; CPR training films; print ads; influencer-led social. Earned a public endorsement from Kiran Mazumdar-Shaw and pickup across business and lifestyle press.",
    metrics: [
      { k: "Earned Media Impressions", v: "1.45Bn+" },
      { k: "Social Engagement Lift", v: "911%+" },
      { k: "QR Scans", v: "12,600+" },
    ],
    press: [
      "Times of India",
      "Hindustan Times",
      "Mint",
      "NDTV",
      "Bangalore Mirror",
      "The Indian Express",
      "Republic",
    ],
  },
  {
    slug: "mission-2-to-3",
    title: "Mission 2 to 3",
    brand: "Manipal Hospitals · Make A Heart Promise",
    year: "World Heart Day · 2023",
    tagline: "We broke a record and the internet too.",
    image:
      "https://customer-assets.emergentagent.com/job_yash-brand-portfolio/artifacts/ntbdl8bg_Case%20Study%20%281%29.png",
    context:
      "A year after Guardians of the Heart, awareness was up but action wasn't. Only 2% of Indians still knew CPR. The platform needed a sequel that converted attention into participation — and gave it a number you couldn't forget.",
    challenge:
      "Only 2% of Indians know CPR. We set out to move that needle — from 2% to 3% — by making the country pledge to learn.",
    insight:
      "Indians value skills that save time, effort and money — but rarely sign up for one that saves a life. A Guinness World Record attempt converts passive consumption into participation.",
    solution:
      "A Guinness World Record attempt for the most CPR pledges in 24 hours, anchored by scannable kiosks across 33+ locations and a 360° digital push that turned CPR education into a national movement.",
    execution:
      "Launched on World Heart Day 2023 with the Make-A-Heart-Promise platform. Scannable kiosks deployed at 33+ Grassroots, mall and corporate locations. A dedicated microsite captured pledges with one-tap form-fill. LinkedIn-led leadership advocacy from healthcare CXOs and corporate communicators. Guinness World Record officially adjudicated on 27–28 September 2023 — 22,319 pledges in 24 hours.",
    metrics: [
      { k: "Pledges in 24 Hours", v: "22,319" },
      { k: "Guinness World Record", v: "Set" },
      { k: "People Reached (Social)", v: "19.9M" },
      { k: "Website Visits", v: "1.2M" },
      { k: "Scannable Locations", v: "33+" },
    ],
    press: ["Guinness World Records", "National coverage"],
  },
  {
    slug: "happy-rebirthday",
    title: "Happy Rebirthday",
    brand: "Manipal Hospitals · Doctors' Day",
    year: "2024",
    tagline: "You can be born only once. But reborn many times.",
    image:
      "https://customer-assets.emergentagent.com/job_yash-brand-portfolio/artifacts/nvyq1500_Happy%20Rebirthday.jpg",
    context:
      "Year three of an emotional Doctors' Day series for Manipal Hospitals. The first two years had humanised the medical profession — this one needed to land an enduring cultural unit that patients themselves would carry forward.",
    challenge:
      "Doctors' Day messaging had become noise. The category needed an emotional anchor that reframed gratitude in a culturally Indian way.",
    insight:
      "In India, gratitude for doctors gets reduced to a 'Thank You' post. But a second chance at life deserves to be celebrated like a birthday — because it is one.",
    solution:
      "An emotional film-first platform celebrating 'rebirthdays' — the day a doctor saved your life. Patients shared their rebirthday on Instagram bios and signed gratitude cards distributed across hospitals. The culmination of a three-year doctor-tribute series.",
    execution:
      "Hero film of a woman celebrating her rebirthday with cake-cutting flashbacks to her life-saving surgery, ending with her offering the first slice to the surgeon who gifted her a new life. UGC engine: patients added their rebirthday dates to Instagram bios with #MyRebirthdayStory. 8,770+ printed rebirthday cards circulated within Manipal Hospitals for patient–doctor handovers across surgery, oncology and transplant units.",
    metrics: [
      { k: "People Reached", v: "4.7M+" },
      { k: "Views", v: "3.6M+" },
      { k: "Rebirthday Cards Shared", v: "8,770+" },
      { k: "Stories Celebrated", v: "1.5M+" },
    ],
    press: ["Earned · Social · UGC"],
  },
  {
    slug: "why-not-for-love",
    title: "Why Not for Love",
    brand: "Helios — A Titan Company · Valentine's Day",
    year: "2025",
    tagline: "On a budget lower than the cost of a new iPhone.",
    image:
      "https://customer-assets.emergentagent.com/job_yash-brand-portfolio/artifacts/nbzx2tjy_WhatsApp%20Image%202026-04-17%20at%2010.08.01%20PM.jpeg",
    context:
      "Helios is a premier multi-brand watch retailer carrying 40+ international brands across premium and fashion segments. On Valentine's — the noisiest gifting period of the year — third-party brands like Calvin Klein, Balmain, Emporio Armani and Guess take centre stage, making the Helios brand nearly invisible.",
    challenge:
      "Valentine's is a cluttered, discount-led sales war for multi-brand retailers. Pricing decides winners — and we had neither the lowest price nor a big budget. We needed to stand out on copy, not coupons.",
    insight:
      "Pop culture sells love as grand gestures. Real love is the person who remembers your coffee order. Each watch became a metaphor for the small, everyday moment a partner notices.",
    solution:
      "A copy-first platform built on a repeatable structure — 'Why not a [Brand]… For the one who [emotional insight].' Each line worked as both communication and CTA, bridging emotion to transaction across cohorts.",
    execution:
      "Performance creatives deployed across Meta and Google for Calvin Klein, Balmain, Emporio Armani, Movado, Victorinox, Maserati, Swarovski, Aigner, Armani Exchange and Guess. A clean visual system kept copy, art direction and product working as one. Each cohort got a tailored insight–brand pairing for relevance at scale.",
    metrics: [
      { k: "Return on Ad Spend", v: "13.6x" },
      { k: "Higher CTR vs Industry", v: "733%" },
      { k: "Reduction in CPA", v: "40%" },
    ],
    press: ["Performance marketing case study"],
  },
  {
    slug: "wegowithyou",
    title: "wegowithyou",
    brand: "Novo Nordisk",
    year: "Pan-India · 2024–25",
    tagline: "Now you can choose your weight.",
    image:
      "https://customer-assets.emergentagent.com/job_yash-brand-portfolio/artifacts/ygv1n4h4_WhatsApp%20Image%202026-06-30%20at%201.13.49%20AM.jpeg",
    context:
      "Obesity in India is treated cosmetically. Genetics, environment, psychology and history all influence weight, but public conversation reduces it to willpower. Novo Nordisk needed to medically reposition the conversation — and reposition itself as the partner that helps you treat it.",
    challenge:
      "Weight loss in India is treated as aesthetics. We needed to reposition obesity as a disease — and Novo Nordisk as the partner that helps you treat it — without sounding clinical or preachy.",
    insight:
      "People don't reject medical help for weight; they reject the shame around asking for it. Reframe 'choose' as agency, not aesthetics.",
    solution:
      "A film-first awareness platform showcasing real characters on medically-guided weight journeys. Times of India print partnership for myth-busting; OOH across Delhi · Mumbai · Bengaluru · Hyderabad · Kochi airports; digital + OTT amplification on Jio Hotstar at peak hours.",
    execution:
      "Hero film with three relatable characters beginning positive, medically-guided weight management journeys. Times of India print collaboration with science-backed obesity facts and statistics. OOH installations at Delhi, Mumbai, Bengaluru, Hyderabad and Kochi airports — high-intent gateway placements. Digital + OTT on Jio Hotstar during peak viewership. Every asset ended with a 'talk to a doctor' CTA.",
    metrics: [
      { k: "Views", v: "7M+" },
      { k: "Reach", v: "4.4M+" },
      { k: "Engagement", v: "484K+" },
    ],
    press: ["Times of India"],
  },
];

export const OTHER_WORK = [
  {
    title: "Museum of Unnecessary Charges",
    brand: "Amazon Now",
    note: "Integrated brand experience — storytelling, activation, consumer engagement.",
  },
  {
    title: "Amazon Now",
    brand: "Amazon",
    note: "Experiential marketing executed from concept through production and deployment.",
  },
  {
    title: "Own Your Body",
    brand: "Featuring Hrithik Roshan",
    note: "Integrated branding campaign with celebrity lead.",
  },
  {
    title: "IPL & WPL Campaign Platforms",
    brand: "Manipal Hospitals · Himalaya Facecare",
    note: "4× IPL for Manipal · 2× WPL for Himalaya Facecare. Multi-season campaign architecture.",
  },
];

export const SKILLS = [
  {
    cluster: "Business",
    items: [
      "Commercial Thinking",
      "Revenue Growth",
      "Client Leadership",
      "Business Development",
      "Relationship Management",
    ],
  },
  {
    cluster: "Strategy",
    items: [
      "Brand Strategy",
      "Integrated Marketing",
      "Campaign Planning",
      "Consumer Insights",
      "Creative Direction",
    ],
  },
  {
    cluster: "Execution",
    items: [
      "Production",
      "Digital",
      "Television",
      "Print",
      "OOH",
      "Experiential",
      "Influencer Marketing",
      "Vendor Management",
    ],
  },
  {
    cluster: "Leadership",
    items: [
      "People Development",
      "Hiring",
      "Mentoring",
      "Stakeholder Management",
      "Cross-functional Collaboration",
    ],
  },
];

export const PROMOTIONS = [
  { year: "2021", title: "Joined Social Panga" },
  { year: "2022", title: "Senior Brand Manager" },
  { year: "2026", title: "Associate Group Head" },
  { year: "2026", title: "Group Head" },
];

export const TECHNOLOGY = [
  "Google Analytics",
  "Meta Ads Manager",
  "Sprinklr",
  "Brandwatch",
  "Notion",
  "Figma",
  "Microsoft Office",
  "Claude AI",
];

export const INDUSTRIES = [
  "Automotive",
  "Alcobev",
  "Consumer Technology",
  "Healthcare",
  "Retail",
  "FMCG",
  "Experiential Marketing",
];

export const NAV = [
  { id: "glance", label: "01 · At a Glance" },
  { id: "about", label: "02 · About" },
  { id: "career", label: "03 · Career" },
  { id: "impact", label: "04 · Impact" },
  { id: "clients", label: "05 · Clients" },
  { id: "campaigns", label: "06 · Campaigns" },
  { id: "skills", label: "07 · Capabilities" },
  { id: "next", label: "08 · What's Next" },
];
